import axios from "axios";

// === Base URL ===
export const BASE_URL = "http://localhost:4001";
// export const BASE_URL = "https://hr-software-bm6w.onrender.com";

// === Auth URLs ===
export const LOGIN_URL = `${BASE_URL}/api/v1/auth/login`;

export const REGISTER_URL = `${BASE_URL}/v1/auth/register`;
export const FORGOT_PASSWORD_URL = `${BASE_URL}/v1/auth/forgot-password`;
export const RESET_PASSWORD_URL = `${BASE_URL}/v1/auth/reset-password`;
export const PROFILE_URL = `${BASE_URL}/v1/auth/getProfile`;
export const USERS_URL = `${BASE_URL}/v1/auth/getUsers`;

// === Axios instance ===
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - add token and tenant slug automatically
api.interceptors.request.use(
  (config) => {
    // Add authorization token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add tenant slug header (optional - only if your backend routes require it)
    const tenantStr = localStorage.getItem("tenant");
    if (tenantStr && tenantStr !== "undefined") {
      try {
        const tenant = JSON.parse(tenantStr);
        if (tenant?.slug) {
          config.headers["x-tenant-slug"] = tenant.slug;
        }
      } catch (e) {
        console.warn("Failed to parse tenant from localStorage");
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor - handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("🔐 Unauthorized - clearing auth data");

      // Clear auth data
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("tenant");

      // Redirect to login (only if not already on login page)
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
